import React from 'react';

import BasePill from '../BasePill';
import type { StatusPillProps } from './types';
import { getStatusPillClasses } from './utils';

const StatusPill = React.forwardRef<HTMLDivElement, StatusPillProps>((props, ref) => {
  const { appearance = 'primary', className, size = 'medium', variant = 'filled', ...rest } = props;
  const classes = getStatusPillClasses(size, variant, appearance);

  return <BasePill ref={ref} className={className} classes={classes} {...rest} />;
});

export default React.memo(StatusPill);
